'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { DivContainer } from './styles';
import useDivProps from './utils/use-div-props';
const Div = forwardRef((props, ref) => {
    const { currentProps, generalProps } = useDivProps(props);
    const { children, onClick, onDoubleClick, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, id, className, } = generalProps;
    return (_jsx(DivContainer, Object.assign({ ref: ref }, currentProps, { className: className, id: id, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, children: children })));
});
Div.displayName = 'Div';
export default Div;
